export default __webpack_public_path__ + "static/media/icon-leads-blue.203c6c28.svg";